// import logo from './logo.svg';
import './App.css';
import Landing from './pages/Landing';
import { ToastContainer, Slide } from 'react-toastify';

function App() {
  return (
    <>
      <ToastContainer
        transition={Slide}
       theme='light'
      />
      <Landing />
    </>

  );
}

export default App;
